module.exports = __webpack_public_path__ + "media/src/images/testimonials/the-flat-ce9cd24b3f559c7f5216b63e71f88451.jpg";